import { isDsnpMember, isMNRMember } from '../../utils/user.utils';

export const filteredLabsAndServices = (
  isBHMember,
  enableBhFacilitiesFlag,
  browseLabsAndServices
) =>
  isBHMember && enableBhFacilitiesFlag
    ? browseLabsAndServices
    : browseLabsAndServices.filter((item) => !item?.bhFacilityProgramIds);

export const filteredSectionMnRDSNPSpecialityCodes = (
  enableMnRDSNPCommunityCentresFF,
  currentMember: any,
  sections: any[],
  codesToRemove: string,
  communityRuralClinicsKey: string
): any[] => {
  const isMnRDSNPMember =
    isMNRMember(currentMember?.lineOfBusiness) && isDsnpMember(currentMember);
  if (isMnRDSNPMember && enableMnRDSNPCommunityCentresFF) return sections;
  if (!sections) return sections;

  const specialtyCodesToRemove = codesToRemove
    .split(',')
    .map((code) => code.trim())
    .filter(Boolean);

  if (!specialtyCodesToRemove.length) return sections;

  return sections.map((section) => {
    if (section?.key !== communityRuralClinicsKey || !section?.specialtyCode) {
      return section;
    }

    const updatedSpecialtyCodes = section.specialtyCode
      .split(',')
      .map((code: string) => code.trim())
      .filter((code: string) => !specialtyCodesToRemove.includes(code))
      .join(', ');
    return { ...section, specialtyCode: updatedSpecialtyCodes };
  });
};

export const COMMUNITY_RURAL_CLINICS_HEADING_KEY = '5';
